
  <div class="address-detail-info__data">
    <retrieval-address-detail-info-data></retrieval-address-detail-info-data>
    <retrieval-address-detail-info-access *ngIf="isContactSection"
                                          [retrievalType]="retrievalType"></retrieval-address-detail-info-access>
  </div>
  <retrieval-address-detail-info-appointments *ngIf="isContactSection" [navigatedAddressId]="addressId"></retrieval-address-detail-info-appointments>
  <retrieval-address-detail-info-grids></retrieval-address-detail-info-grids>
